import { convertToFloat } from '@/utilz';
import { Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import FormInput from '../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../components/Inputs/HiddenFormInput';
import Paper from '../../../../../components/Paper/Paper';
import ClaimsChargeSelector from '../../../../../components/Selectors/ClaimsChargeSelector';
import SaveCancelButtons from '../../../../Shipment/components/SaveCancelButtons';

const LADSettlementCard = ({
  editMode = false,
  isLastItem = false,
  shadowVisible = true,
  index = 0,
  settlementDetails,
  setEditMode,
  handleCancel,
  handleSubmit,
  handleDelete,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (settlementDetails) {
      form.setFieldsValue(settlementDetails);
    }
  }, [settlementDetails, form]);

  const convertAmountToFloat = () => {
    const amount = form.getFieldValue('amount');
    form.setFieldsValue({ amount: convertToFloat(amount) });
  };

  return (
    <Paper className={`border-muted ${!isLastItem ? 'mb-16' : ''} ${shadowVisible ? '' : 'shadow-none'}`}>
      <Form onFinish={(data) => handleSubmit(data, index)} initialValues={settlementDetails} form={form}>
        <div className="pt-8 pb-10 px-16">
          <Row justify="space-between" gutter={30}>
            <Col sm={6}>
              <ClaimsChargeSelector
                tabIndex={(index + 1) * 2 + 40000 + 1}
                editMode={editMode}
                margin="mb-0"
                name="chargeCode"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Charge Code',
                  },
                ]}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                tabIndex={(index + 1) * 2 + 40000 + 2}
                label="Accounting Code"
                placeholder="Enter Accounting Code"
                margin="mb-0"
                name="accountingCode"
                editMode={editMode}
                maxLength={26}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                tabIndex={(index + 1) * 2 + 40000 + 3}
                label="Amount"
                placeholder="Enter Amount"
                margin="mb-0"
                name="amount"
                editMode={editMode}
                rules={[
                  {
                    required: true,
                    message: 'Please enter Amount',
                  },
                ]}
                inputType="number"
                onBlur={convertAmountToFloat}
              />
            </Col>
            <Col className="flex-1">
              <Row align="middle" justify="end">
                <Col>
                  <SaveCancelButtons
                    editMode={editMode}
                    lightMode={false}
                    setEditMode={(val) => setEditMode(index, val)}
                    handleRemove={handleDelete(index)}
                    isNew={settlementDetails.isNew}
                    idSuffix={`product-details-${index + 1}`}
                    isModified
                    onCancel={handleCancel(index, settlementDetails.isNew)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <HiddenFormInput name="settlementSeq" />
        <HiddenFormInput name="isNew" />
        <HiddenFormInput name="editMode" />
        <HiddenFormInput name="claimKey" />
      </Form>
    </Paper>
  );
};

export default LADSettlementCard;
